import { FormattedMessage } from 'react-intl';
import { Option } from 'react-select';

import {
    DEBIT_CARD_TYPE,
    MANUAL_BANK_TRANSFER_TYPE,
    TRUELAYER_REPAYMENT_TYPE
} from '../EarlyRepaymentHelper';
import { PaymentMethodLogo } from './PaymentMethodLogo';
import styles from './PaymentMethodOption.module.css';

export class PaymentMethodOption extends Option {
    renderPaymentMethod(type) {
        const { option, instancePrefix, optionIndex } = this.props;
        return (
            <div
                className={styles.PaymentMethodOption}
                style={option.style}
                role="option"
                aria-label={option.label}
                aria-selected="true"
                onMouseDown={this.handleMouseDown}
                onMouseEnter={this.handleMouseEnter}
                onMouseMove={this.handleMouseMove}
                onTouchStart={this.handleTouchStart}
                onTouchMove={this.handleTouchMove}
                onTouchEnd={this.handleTouchEnd}
                id={instancePrefix + '-option-' + optionIndex}
                title={option.title}
            >
                {type === 'BANK_ACCOUNT' ? (
                    <BankAccountLabel
                        label={option.label}
                        issuer={option.issuer}
                    />
                ) : (
                    <CardLabel
                        cardLastDigits={option.cardLastDigits}
                        issuer={option.issuer}
                    />
                )}
            </div>
        );
    }

    renderManualPaymentMethod() {
        const { option, instancePrefix, optionIndex } = this.props;
        const className = styles.PaymentMethodOption;

        return (
            <div
                className={className}
                style={option.style}
                role="option"
                aria-label={option.label}
                aria-selected="true"
                onMouseDown={this.handleMouseDown}
                onMouseEnter={this.handleMouseEnter}
                onMouseMove={this.handleMouseMove}
                onTouchStart={this.handleTouchStart}
                onTouchMove={this.handleTouchMove}
                onTouchEnd={this.handleTouchEnd}
                id={instancePrefix + '-option-' + optionIndex}
                title={option.title}
            >
                <ManualBankTransferLabel />
            </div>
        );
    }

    renderTruelayerRepayment() {
        const { option, instancePrefix, optionIndex } = this.props;
        const className = styles.PaymentMethodOption;

        return (
            <div
                className={className}
                style={option.style}
                role="option"
                aria-label={option.label}
                aria-selected="true"
                onMouseDown={this.handleMouseDown}
                onMouseEnter={this.handleMouseEnter}
                onMouseMove={this.handleMouseMove}
                onTouchStart={this.handleTouchStart}
                onTouchMove={this.handleTouchMove}
                onTouchEnd={this.handleTouchEnd}
                id={instancePrefix + '-option-' + optionIndex}
                title={option.title}
            >
                <TruelayerLabel />
            </div>
        );
    }

    render() {
        const {
            option: { type }
        } = this.props;

        switch (type) {
            case MANUAL_BANK_TRANSFER_TYPE:
                return this.renderManualPaymentMethod();
            case DEBIT_CARD_TYPE:
            case 'BANK_ACCOUNT':
                return this.renderPaymentMethod(type);
            case TRUELAYER_REPAYMENT_TYPE:
                return this.renderTruelayerRepayment();
        }
    }
}

const CardLabel = ({ cardLastDigits, issuer }) => (
    <div className={styles.labelContainer}>
        <PaymentMethodLogo
            type={DEBIT_CARD_TYPE}
            issuer={issuer}
            logoStyle={styles.icon}
        />
        <FormattedMessage
            id="_.select_payment_method.card_option"
            defaultMessage="Card ●●●● {cardLastDigits}"
            values={{ cardLastDigits: cardLastDigits }}
        />
    </div>
);

const BankAccountLabel = ({ label, issuer }) => (
    <div className={styles.labelContainer}>
        <PaymentMethodLogo
            type={DEBIT_CARD_TYPE}
            issuer={issuer}
            logoStyle={styles.icon}
        />
        <FormattedMessage
            id="_.select_payment_method.bank_account_option"
            defaultMessage="Account {accountNumber}"
            values={{ accountNumber: label }}
        />
    </div>
);

const ManualBankTransferLabel = () => (
    <div className={styles.labelContainer}>
        <PaymentMethodLogo
            type={MANUAL_BANK_TRANSFER_TYPE}
            logoStyle={styles.icon}
        />
        <FormattedMessage
            id="_.select_payment_method.manual_payment"
            defaultMessage="Manual Bank Transfer"
        />
    </div>
);

const TruelayerLabel = () => (
    <div className={styles.labelContainer}>
        <PaymentMethodLogo
            type={TRUELAYER_REPAYMENT_TYPE}
            logoStyle={styles.icon}
        />
        <FormattedMessage
            id="_.select_payment_method.truelayer_repayment"
            defaultMessage="Instant Bank Transfer"
        />
        <span className={styles.recommendedTag}>Recommended</span>
    </div>
);
